<template>
  <div class="disease">
    <tabs @updateList="handleGetList"></tabs>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" class="cons-div">
      <div class="item-div" v-for="(item, index) in list" :key="index" @click.stop="handleClick(item)">
        <items :dataProps="item" :typeTxt="'colDisease'" @handleCol="handleCol(item, index)"></items>
      </div>
    </van-list>
    <van-overlay :show="isColVisiable" @click="isColVisiable = false">
      <div class="wrap" @click.stop>
        <div class="wrap-txt">提示</div>
        <div class="wrap-con">是否确定取消收藏该病种？</div>
        <div class="warp-btn">
          <div class="btn btn1" @click="isColVisiable = false">取消</div>
          <div class="btn btn2" @click="handleColConfirm">确认</div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import items from './components/items.vue'
import tabs from './components/tabs.vue'
import {getCollectBankList, delCollect} from '../../api/questionBank'
import { getShareInfo } from '@/utils/wxShare'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  components: {
    items,
    tabs
  },
  data () {
    return {
      isColVisiable: false,
      curObj: null,
      curIndex: '',
      list: [],
      loading: false,
      finished: false,
      pageNo: 1,
      pageSize: 10,
      classCode: '',
      difficultyLevel: '',
      load: false
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  mounted() {
    getShareInfo({
      title: 'iEP-心电图分类题库',
      titleTimeLine: 'iEP-海量心电图分类题库，进阶心电王者',
      desc: '解锁更多题目，进阶心电王者',
      link: window.location.href + `${window.location.href.indexOf('?') > -1 ? '&' : '?'}shareColl=true`,
      linkTimeLine: window.location.href + `${window.location.href.indexOf('?') > -1 ? '&' : '?'}shareColl=true`,
      images: `https://iep.jjmc.cn/bw/file/material/image/1933146816339349528.jpg`,
    })
  },
  methods: {
    handleColConfirm() {
      let params = {
        userId: this.userInfo.id,
        classCode: this.curObj.classCode,
        difficultyLevel: this.curObj.difficultyLevel
      }
      delCollect(params).then(result => {
        if (this.list.length === 0) {
          this.list = []
        } else {
          this.list.splice(this.curIndex, 1)
        }
        this.isColVisiable = false
      })
    },
    handleCol(item, index) {
      this.curObj = item
      this.curIndex = index
      this.isColVisiable = true
    },
    handleClick (item) {
      this.$router.push({
        path: `/colSubject?classCode=${item.classCode}&className=${item.className}&difficultyLevel=${item.difficultyLevel}&isSubject=true`
      })
    },
    handleGetList (e) {
      this.difficultyLevel = e.curLevel
      this.classCode = e.curEffec
      this.list = []
      this.loading = false
      this.finished = false
      this.pageNo = 1
      this.onLoad()
    },
    onLoad () {
      if (this.load) {
        return
      }
      this.load = true
      this.$toast.loading({ message: '加载中...' })
      let params = {
        pageNum: this.pageNo,
        pageSize: this.pageSize,
        classCode: this.classCode,
        difficultyLevel: this.difficultyLevel,
      }
      getCollectBankList(params)
        .then(res => {
          this.load = false
          this.$toast.clear()
          if (res) {
            if (res.code !== 0 || !res.data || !res.data.list) {
              this.loading = false
              this.finished = true
              return false
            }
            res.data.list = res.data.list.map(item => {
              item.type = 'bank'
              return item
            })
            if (res.data.list.length < this.pageSize) {
              this.finished = true
            }
            if (res.code === 0 && res.data.list) {
              this.list = this.list.concat(res.data.list)
            }
            this.pageNo++
            if (this.list.length === 0) {
              this.isNone = true
            }
            this.loading = false
          }
        })
        .catch(err => {
          this.$toast.clear()
          console.log('err:', err)
        })
    }
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
/deep/ .van-overlay {
  z-index: 9999;

  .wrap {
    width: 320px;
    border-radius: 10px;
    background-color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 20px;
    box-sizing: border-box;

    .img-wrap {
      width: 80px;
      display: block;
      margin-bottom: 18px;
      margin-left: 50%;
      transform: translateX(-50%);
    }

    .wrap-txt {
      font-size: 17px;
      line-height: 24px;
      font-weight: 600;
      color: #000000;
      text-align: center;

    }

    .wrap-con {
      color: rgb(0, 0, 0);
      font-family: PingFang SC;
      font-size: 17px;
      font-weight: 300;
      line-height: 23.8px;
      letter-spacing: 0px;
      text-align: center;
      margin: 26px 0;
    }

    .warp-btn {
      display: grid;
      grid-template-columns: 1fr 1fr;
      column-gap: 8px;
      height: 55px;
      box-sizing: border-box;

      .btn {
        text-align: center;
        font-size: 17px;
        font-weight: 500;
        border-radius: 30pc;
        height: 42px;
        line-height: 42px;

        &.btn1 {
          color: #81766F;
          background: #F1EFED;
        }

        &.btn2 {
          background: #EB1700;
          color: #fff;
        }
      }
    }
  }
}
.disease {
  min-height: 100vh;
  background-color: #F7F9FB;

  .cons-div {
    box-sizing: border-box;
    padding: 8px 15px;
    display: flex;
    flex-wrap: wrap;

    .item-div {
      width: 111px;
      background-color: #Fff;
      margin-bottom: 8px;
      position: relative;
      padding: 0 8px;
      height: 170px;
      padding-bottom: 4px;
      box-sizing: border-box;

      &:nth-child(3n-1) {
        margin: 0 6px;
        margin-bottom: 8px;
      }
    }
  }
}

/deep/ .van-list__finished-text {
  width: 100%;
  display: block;
}

/deep/ .van-list__loading {
  width: 100%;
}</style>



// WEBPACK FOOTER //
// src/views/questionBank/colDisease.vue